<template>
  <Analytics />
  <div class="cursor cursor--outer"></div>
  <div class="cursor cursor--inner"></div>
  <SiteHeader />

  <SiteSidebar ref="sidebarRef" :title="title" :description="description" />
  <main class="container">
    <RouteLoadingScreen ref="loadingScreenRef" />
    <router-view v-slot="{ Component, route }">
      <transition :name="route.meta.transition || 'fade'" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
  </main>
  <SiteFooter class="mobile-only" />
</template>

<script setup>
import { ref, onMounted } from "vue";
import { setSidebarRef, setSidebarUpdateFn } from "./router/index.js";
import { provideSidebar } from "./composables/useSidebar.js";
import { setLoadingScreenRef } from "./composables/useRouteLoading.js";
import SiteSidebar from "@/components/layout/SiteSidebar.vue";
import SiteHeader from "@/components/layout/SiteHeader.vue";
import SiteFooter from "@/components/layout/SiteFooter.vue";
import RouteLoadingScreen from "@/components/layout/RouteLoadingScreen.vue";
import { Analytics } from "@vercel/analytics/vue";

const sidebarRef = ref(null);
const { title, description, updateSidebarForRoute } = provideSidebar();
const loadingScreenRef = ref(null);

onMounted(() => {
  setSidebarRef(sidebarRef.value);
  setSidebarUpdateFn(updateSidebarForRoute);
  setLoadingScreenRef(loadingScreenRef.value);
});
</script>

<style lang="scss">
@import "./styles/style.sass";

.container {
  position: relative;
}

.mobile-only {
  display: none;
}

@media (max-width: 40rem) {
  .mobile-only {
    display: flex;
  }
}
</style>
